import { IconName } from '../../../assets/icons';
import SvgIcon from '../../SvgIcon/SvgIcon';

interface Action {
  label: string;
  icon?: IconName;

  color?:
    | 'primary'
    | 'danger'
    | 'success'
    | 'secondary'
    | 'warning'
    | 'dark'
    | 'info';

  onClick: (row: any) => void;
}

interface MobileTableActionsProps {
  row: any;
  actions: Action[] | ((row: any) => Action[]);
}

// =====================================================
// 🎨 Variantes (mismas que DesktopTableActions)
// =====================================================

const colorClasses: Record<NonNullable<Action['color']>, string> = {
  primary: `
    bg-primary
    text-white

    hover:opacity-90
  `,

  success: `
    bg-success
    text-white

    hover:opacity-90
  `,

  warning: `
    bg-warning
    text-black

    hover:opacity-90
  `,

  danger: `
    bg-danger
    text-white

    hover:opacity-90
  `,

  info: `
    bg-meta-10
    text-white

    hover:opacity-90
  `,

  dark: `
    bg-meta-4
    text-white

    hover:opacity-90
  `,

  secondary: `
    border
    border-stroke

    bg-white
    text-black

    hover:bg-whiten

    dark:border-strokedark
    dark:bg-boxdark
    dark:text-white
    dark:hover:bg-meta-4
  `,
};

const MobileTableActions: React.FC<MobileTableActionsProps> = ({
  row,
  actions,
}) => {
  const resolvedActions =
    typeof actions === 'function' ? actions(row) : actions;

  if (!Array.isArray(resolvedActions)) {
    return null;
  }

  return (
    <div className="mt-4 flex flex-col gap-2">
      {resolvedActions.map((action, index) => (
        <button
          key={index}
          type="button"
          onClick={() => action.onClick(row)}
          className={`
            inline-flex
            w-full
            items-center
            justify-center
            gap-2

            rounded-xl

            px-4
            py-3

            text-sm
            font-medium

            shadow-1

            transition-all
            duration-200

            hover:scale-[1.01]
            active:scale-[0.99]

            ${colorClasses[action.color ?? 'primary']}
          `}
        >
          {action.icon && <SvgIcon name={action.icon} width={16} height={16} />}

          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MobileTableActions;
